import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ContactUs from '../sections/ContactUs'
import Seo from '../components/Seo'
import { sizes } from '../utils/breakpoints'

const Contacto = () => {
  const { t } = useTranslation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title={t('seo.contacto.title')}
        description={t('seo.contacto.description')}
        path="/contacto"
      />
      <ContactUs />
    </Container>
  )
}

export default Contacto

const Container = styled.div`
  padding-top: 90px;

  @media (min-width: ${sizes.mobile + 1}px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100vh - 90px);
  }

  @media (max-width: ${sizes.mobile}px) {
    padding-top: 70px;
  }
`
